import React from "react";
import { EuiSpacer, EuiPageContent, EuiPageContentBody } from "@elastic/eui";
import { Outlet } from "react-router";

export const AnketaQuereinarieHome = (): JSX.Element => {
  return (
    <>
      <EuiSpacer />
      <EuiPageContent>
        <EuiPageContentBody>
          <Outlet />
        </EuiPageContentBody>
      </EuiPageContent>
    </>
  );
};
